import { PractitionerManagementService } from "src/app/ui/services/pbm/practitioner-management.service";
import { PagingRequest } from "../paginator/paging-request";
import { PractitionerSpecialty } from "../pbm/practitioner-management/practitioner-specialty";
import { IAutoCompleteSearchProvider } from "./iauto-complete-search-provider";
import { PractitionerSpecialtyAutoCompleteItem } from "./practitioner-specialty-auto-complete-item";

export class PractitionerSpecialtyAutoCompleteProvider implements IAutoCompleteSearchProvider {
  constructor(private practitionerManagementService: PractitionerManagementService) {}

  public async search(filterByText: string = ""): Promise<PractitionerSpecialtyAutoCompleteItem[]> {
    const filteredItems: PractitionerSpecialtyAutoCompleteItem[] = [];

    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(0);
    pagingRequest.setEnd(50);
    pagingRequest.setFilterText(filterByText);

    const specialties = await this.practitionerManagementService.getSpecialties(pagingRequest);

    specialties.map((item) => {
      filteredItems.push(new PractitionerSpecialtyAutoCompleteItem(item));
    });

    return Promise.resolve(filteredItems);
  }
}
